import React from 'react';
import { Environment } from 'src/Environment';
import { CopyToClipboard, Error as TechnicalErrorIcon } from 'src/assets/images';
import { Tooltip } from 'src/components';
import * as Sentry from '@sentry/react';
import { Button, Modal } from 'src/features/common';
import {
  ButtonParamType,
  DefaultButtonStyle,
} from 'src/features/common/components/button/revamp-button';
import { v4 } from 'uuid';

interface Props {
  visible: boolean;
  onRetry: () => void;
  onClose: () => void;
  error?: Error;
}

export function TechnicalErrorModal(props: Props) {
  const uuid = v4().replace(/-/g, '');
  React.useEffect(() => {
    if (!Environment?.current?.disabledFeatures?.sentry) {
      Sentry.captureMessage(`${uuid}: ${props?.error?.message}`, 'error');
    }
  }, []);

  const copyUuidToClipboard = () => navigator.clipboard.writeText(uuid || '');

  return (
    <Modal visible={props.visible} size="small">
      <section className="grid gap-10 text-center text-grey-600">
        <div className="md:px-20 flex flex-col gap-4 items-center text-center">
          <img className="w-20 h-20" src={TechnicalErrorIcon} />
          <h1 className="md:text-4xl text-2xl font-medium">Technical Issue</h1>
          <div className="flex text-xs md:text-base items-center flex-1 gap-4 text-grey-400">
            <p>{uuid}</p>
            {/* @ts-ignore */}
            <Tooltip content="Copied!" showOnClick copyToClipboard>
              <img
                className="!w-4 !h-4  !max-w-4 cursor-pointer"
                src={CopyToClipboard}
                alt="Copy"
                onClick={copyUuidToClipboard}
              />
            </Tooltip>
          </div>
          <p className="md:text-base text-sm text-grey-400">
            We’re sorry, but we’re experiencing technical difficulties. Please try again.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <Button
            type={'button'}
            buttonStyle={DefaultButtonStyle()
              .hasPrimaryAction()
              .isMediumSize()
              .hasLightMode()
              .build()}
            buttonParams={{
              type: ButtonParamType.NormalButton,
              onClick: props.onRetry,
            }}
            className="w-56 !rounded-40"
          >
            Retry
          </Button>

          <Button
            type={'button'}
            buttonStyle={DefaultButtonStyle()
              .hasSecondaryAction()
              .isMediumSize()
              .hasLightMode()
              .build()}
            buttonParams={{
              type: ButtonParamType.NormalButton,
              onClick: props.onClose,
            }}
            className="w-56 !rounded-40 !text-black"
          >
            Close
          </Button>
        </div>
      </section>
    </Modal>
  );
}
